import { Filter, PaginatedResponse } from '@libs/models/common';
import { request } from '../request';
import { filterToQueryParams } from '../utils/filterToQueryParams';
import { InvitationRequestListItem } from '@libs/models/invitationRequests';

type fetchInvitationRequestsListParams = {
  search?: string;
  page?: number;
  size?: number;
  filters?: Filter[];
};
export async function fetchInvitationRequestsList(
  params?: fetchInvitationRequestsListParams,
): Promise<PaginatedResponse<InvitationRequestListItem[]>> {
  const filters = filterToQueryParams((params?.filters ?? []).map((fil) => ({ field: fil.key, value: fil.value })));

  const response = await request.get<PaginatedResponse<AgenciesResponseItem[]>>('/agencies', {
    params: {
      pageNumber: params?.page || 1,
      pageSize: params?.size || 50,
      search: params?.search || undefined,
      ...filters,
    },
  });
  return {
    ...response.data,
    items: response.data.items.map((item) => ({
      ...item,
      status: item.status ?? 'Active',
      orgType: 'agency',
    })),
  };
}

type AgenciesResponseItem = {
  id: string;
  name: string;
  tenantId: string;
  createdOn: string;
  agencyType: string;
  linesOfBusiness: string[];
  contact: {
    email: string;
    firstName: string;
    phoneNumber: string;
    lastName: string;
  };
  address: {
    addressLine1: string;
    addressLine2: string;
    city: string;
    state: string;
    zipCode: string;
  };
  status: 'Pending' | 'Disconnected' | 'Active' | 'OnReview' | 'Invited';
};
